import { useState } from "react";
import { Info as InfoIcon } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

// Lote 115 (Robson, 24/10/2026) — explicações e dicas não ocupam a tela inteira:
//  - <Dica>: mostra só o começo (a primeira frase) e "ler mais ›" para abrir o texto todo (1 toque);
//    texto curto (até ~90 caracteres) aparece inteiro, como antes;
//  - <Info>: a bolinha "i" ao lado de um título; 1 toque abre a caixa explicando e ela fecha ao tocar fora.
// Alertas, erros e avisos de segurança NÃO usam isto: ficam sempre visíveis.
export function primeiraFrase(texto, max = 90) {
  const t = String(texto || "").replace(/\s+/g, " ").trim();
  if (t.length <= max) return { curto: t, cortou: false };
  const m = /^(.{20,}?[.!?;:])\s/.exec(t.slice(0, max + 40));
  if (m && m[1].length <= max + 25) return { curto: m[1], cortou: m[1].length < t.length };
  const corte = t.slice(0, max).replace(/\s+\S*$/, "");
  return { curto: `${corte}…`, cortou: true };
}

export function Dica({ children, max = 90, className = "text-[11px] text-stone-500", ...rest }) {
  const [aberta, setAberta] = useState(false);
  const texto = typeof children === "string" ? children : String(children ?? "");
  const { curto, cortou } = primeiraFrase(texto, max);
  if (!cortou) return <p className={className} {...rest}>{texto.replace(/\s+/g, " ").trim()}</p>;
  return (
    <p className={className} {...rest}>
      {aberta ? texto.replace(/\s+/g, " ").trim() : curto}{" "}
      <button type="button" data-testid="dica-toggle" aria-expanded={aberta} onClick={() => setAberta((a) => !a)}
        className="font-semibold text-gold-800 underline underline-offset-2 hover:text-gold-900 whitespace-nowrap">
        {aberta ? "ler menos" : "ler mais ›"}
      </button>
    </p>
  );
}

export function Info({ children, titulo = "Explicação", className = "" }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" data-testid="info-toggle" aria-label={titulo}
          className={`inline-flex items-center justify-center w-[18px] h-[18px] rounded-full border border-[#8cc7f5] bg-[#f3f9ff] text-[#0b4f94] hover:bg-[#e3f1fd] align-middle ${className}`}>
          <InfoIcon className="w-3 h-3" strokeWidth={2.25} />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-72 max-w-[85vw] text-xs leading-relaxed text-stone-700 border-[#8cc7f5]" data-testid="info-conteudo">
        {children}
      </PopoverContent>
    </Popover>
  );
}

export default Dica;
